<template>
  <v-app class="pa-2" v-show="!progress">
    <!-- ふきだし -->
    <v-container v-if="order">
      <OrderDetailBubble :order="order" />
    </v-container>

    <!-- メニュー一覧 -->
    <v-container v-if="order">
      <OrderDetail :mode="0" :order="order" :showReOrder="true" />
    </v-container>

    <!-- デバッグ用 -->
    <!-- <v-row v-if="showDebug && order.payType == 0">
        <v-col align="center" class="pt-0">
          <v-btn
            large
            tile
            text
            outlined
            style="width: 100%"
            @click="refundLinePay"
            >支払キャンセル (LINE Pay)</v-btn
          >
        </v-col>
      </v-row>
      <v-row v-if="showDebug && order.payType == 1">
        <v-col align="center" class="pt-0">
          <v-btn
            large
            tile
            text
            outlined
            style="width: 100%"
            @click="refundPayPay"
            >支払キャンセル (PayPay)</v-btn
          >
        </v-col>
      </v-row> -->
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import OrderDetailBubble from "./parts/OrderDetailBubble";
import OrderDetail from "./parts/OrderDetail";
import { MSG_TYPE } from "../components/error/errorConstants";

export default {
  components: {
    OrderDetailBubble,
    OrderDetail,
  },
  name: "History",
  props: {},
  data: () => ({
    bubbleContent: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "注文履歴";
    this.$store.state.cart = true;
  },
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();
    try {
      await this.fetchData();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.replace({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress", "order"]),
  },
  methods: {
    ...mapActions(["showProgress", "hideProgress", "fetchHistoryData"]),
    fetchData: async function () {
      const id = this.$route.params.id;
      return this.fetchHistoryData({ id });
    },
    // refundLinePay: async function () {
    //   console.log("refundLinePay");

    //   // ローディング(開始)
    //   this.$store.state.progress = true;
    //   const urlBase = process.env.VUE_APP_URL_BASE_LINEPAY;
    //   const payReqUrl = `${urlBase}/pay/refund`;
    //   console.log("payReqUrl", payReqUrl);
    //   const payload = this.createPayloadRefundLINEPay();
    //   console.log("payload", payload);
    //   const res = await this.axios.post(payReqUrl, payload).catch(function (e) {
    //     console.error(e);
    //   });
    //   if (res) {
    //     // snackbar 表示
    //     console.log("res", res);
    //     const returnCode = res.data.returnCode;
    //     const returnMessage = res.data.returnMessage;
    //     const message = `[${returnCode}] ${returnMessage}`;
    //     this.snackbarText = `${message}`;
    //     this.snackbar = true;
    //   }

    //   // ローディング(終了)
    //   this.$store.state.progress = false;
    // },
    // createPayloadRefundLINEPay: function () {
    //   const orderId = this.order.orderId;
    //   const userId = this.$store.getters.userId;
    //   const transactionId = this.order.transactionId;
    //   const amountInfo = {
    //     amount: this.order.amount,
    //     currency: this.order.currency,
    //   };
    //   return {
    //     orderId: orderId,
    //     userId: userId,
    //     transactionId: transactionId,
    //     amountInfo: amountInfo,
    //   };
    // },
    // refundPayPay: async function () {
    //   // ローディング(開始)
    //   this.$store.state.progress = true;

    //   const urlBase = process.env.VUE_APP_URL_BASE_PAYPAY;
    //   const payReqUrl = `${urlBase}/pay/refund`;
    //   console.log("payReqUrl", payReqUrl);

    //   const payload = this.createPayloadRefundPayPay();
    //   console.log("payload", payload);

    //   const res = await this.axios.post(payReqUrl, payload).catch(function (e) {
    //     console.error(e);
    //   });
    //   if (res) {
    //     // snackbar 表示
    //     console.log("res", res);
    //     const codeId = res.data.resultInfo.codeId;
    //     const returnMessage = res.data.resultInfo.message;
    //     const message = `[${codeId}] ${returnMessage}`;
    //     this.snackbarText = `${message}`;
    //     this.snackbar = true;
    //   }

    //   // ローディング(終了)
    //   this.$store.state.progress = false;
    // },
    // createPayloadRefundPayPay: function () {
    //   const orderId = this.order.orderId;
    //   const userId = this.$store.getters.userId;
    //   const paymentId = this.order.paymentId;
    //   const amountInfo = {
    //     amount: this.order.amount,
    //     currency: this.order.currency,
    //   };
    //   return {
    //     orderId: orderId,
    //     userId: userId,
    //     paymentId: paymentId,
    //     amountInfo: amountInfo,
    //   };
    // },
  },
};
</script>
